/**
 * @Description 选择文件夹弹窗
 */

import { Button, Checkbox, Input, Modal, Space } from 'antd';
import styles from './index.module.less';
import { FC, useEffect, useMemo, useState } from 'react';
import IconFont from '@/common/components/IconFont';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { post } from '@/common/request';
import { getFavoriteList } from '@/common/api/siteselectionmap';
import { handleCollectOfFetch } from '@/common/api/siteselectionmap';
import { useUnactivate } from 'react-activation';
// import { bigdataBtn } from '@/common/utils/bigdata';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { isArray } from '@lhb/func';
import { useContext } from 'react';
import useLatest from '@/common/hook/useLatest';
// import { useBigdataFn } from '@/common/utils/bigdata';
import { globalOpeningAreaAlias } from '@/common/utils/ways';
import UserInfoContext from '@/layout/context';
import { CollectListContext } from '@/views/youth/pages/map/ts-config';

const PickFolderModal: FC<{
  open,
  clusterId, // 商圈ID
  clusterIds?, // 批量收藏时
  spotId, // 点位ID
  // build, // true为加入收藏，false为取消收藏
  setOpen,
  setCollectStatus, // 收藏/取消收藏时更新状态
  callFn?, // 回调
  modelConfigId
}> = ({
  open,
  clusterId, // 商圈ID
  clusterIds, // 批量收藏时
  spotId, // 点位ID
  // build, // true为加入收藏，false为取消收藏
  setOpen,
  setCollectStatus, // 收藏/取消收藏时更新状态
  callFn, // 回调
  modelConfigId
}) => {
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [isAddFolder, setIsAddFolder] = useState<any>(false);
  const [selected, setSelected] = useState<CheckboxValueType[]>([]);
  const [addFolderName, setAddFolderName] = useState('');
  const [folderList, setFolderList] = useState<any>([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [repeatTip, setRepeatTip] = useState('');
  const [showSpotFlag, setShowSpotFlag] = useState(false);

  const { setCollectList }: any = useContext(CollectListContext) || {};
  const modelConfigIdRef = useLatest(modelConfigId);

  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息

  const openingAreaTaskAlias = useMemo(() => {
    return globalOpeningAreaAlias(globalAliasItemVOs);
  }, [globalAliasItemVOs]);

  useEffect(() => {
    if (!open) return;
    getFolderList();
  }, [open]);

  // 选址地图页被缓存,离开当前页面时，关闭抽屉/弹窗
  useUnactivate(() => {
    onCancel();
  });

  /**
   * @description 获取文件夹列表
   */
  const getFolderList = async () => {
    if (modelConfigIdRef.current === -1) return;
    const params: any = { modelConfigId: modelConfigIdRef.current };
    if (clusterId) params.clusterId = clusterId; // 商圈ID
    if (spotId) params.locationId = spotId; // 点位ID
    const { favoriteFolderListVOS: data, siteLocationFlag } = await getFavoriteList(params);
    setFolderList(isArray(data) ? data : []);
    setShowSpotFlag(siteLocationFlag);
    const targetSelected: Array<number> = [];
    data?.forEach((item: any) => {
      item.containFlag && (targetSelected.push(item.id));
    });
    setSelected(targetSelected);
  };

  /**
   * @description 选择文件夹复选框事件
   */
  const checkboxChange = (checkedValues: CheckboxValueType[]) => {
    setSelected(checkedValues);
  };

  /**
   * @description 添加收藏夹
   */
  const addFolder = async () => {
    if (!addFolderName || addFolderName.trim() === '') {
      V2Message.warning('请输入收藏夹名称');
      return;
    }
    try {
      // https://yapi.lanhanba.com/project/546/interface/api/70195
      await post('/clusterLocationFavor/saveFolder', { name: addFolderName }, { needHint: false });
      V2Message.success('添加成功');
      // bigdataFn('11fabca5-5061-4082-860c-ea9c480e3b76', '添加收藏夹', '点击了添加收藏夹', { op_block: '开店区域', op_event: addFolderName || '', });
      closeAddFolder();
      getFolderList();
    } catch (err: any) {
      setRepeatTip(err.response?.data?.errMsg);
    }
  };
  // 取消添加收藏夹
  const closeAddFolder = () => {
    setIsAddFolder(false);
    setAddFolderName('');
    setRepeatTip('');
  };

  const onSubmit = () => {
    // if (!selected.length) {
    //   V2Message.warning('请选择收藏夹');
    //   return;
    // }
    const params: any = {
      // build: false,
      favourFolders: selected,
    };
    // 点位ID 与 商圈ID 有且只能有一个有效
    if (clusterId) {
      params.clusterId = clusterId;
    } else if (isArray(clusterIds) && clusterIds.length) {
      params.clusterIds = clusterIds;
    } else if (spotId) {
      params.locationId = spotId;
    }
    // 批量收藏时，hasSelected一定为false
    const hasSelected = folderList?.find((item: any) => item.containFlag); // 是否之前有选中
    if (!hasSelected && params.favourFolders.length === 0) {
      V2Message.warning('请选择收藏夹');
      return;
    }
    setConfirmLoading(true);
    // https://yapi.lanhanba.com/project/546/interface/api/70188
    // post('/clusterLocationFavor/build', { clusterId: null, locationId: null, build: true, favourFolders: selected }).then(() => {
    handleCollectOfFetch(params).then(() => {
      // V2Message.success(build ? '收藏成功' : '已取消收藏');
      // V2Message.success(`操作成功`);
      let hintStr = '';
      // const hasSelected = folderList?.find((item: any) => item.containFlag); // 是否之前有选中
      if (hasSelected && params.favourFolders.length === 0) { // 说明取消选中
        hintStr = '取消收藏成功';
      } else if (params.favourFolders.length > 0) {
        hintStr = isArray(clusterIds) && clusterIds.length ? '批量收藏成功' : '操作成功';
      }
      hintStr && V2Message.success(hintStr);
      setCollectStatus && setCollectStatus(!!selected.length);
      if (clusterId) {
        setCollectList?.((state) => {
          if (selected?.length) {
            return Array.from(new Set([...state, clusterId]));
          } else {
            return state?.filter((item) => item !== clusterId);
          }
        });
      } else if (clusterIds?.length && selected?.length) { // 批量收藏时
        setCollectList?.((state) => Array.from(new Set([...state, ...clusterIds])));
      }
      onCancel();
      callFn && callFn();
    }).finally(() => setConfirmLoading(false));
  };

  const onCancel = () => {
    setIsAddFolder(false);
    setSelected([]);
    setAddFolderName('');
    setOpen(false);
  };

  const btnStyle:any = { // 禁用按钮样式
    backgroundColor: '#c9e1fe',
    color: '#fff',
    borderRadius: '4px'
  };

  return (
    <Modal
      bodyStyle={{ paddingBottom: 0 }}
      keyboard={false}
      title='选择收藏夹'
      open={open}
      // confirmLoading={confirmLoading}
      onCancel={onCancel}
      footer={
        <>
          <Button type='primary' loading={confirmLoading} disabled={isAddFolder} onClick={onSubmit} style={isAddFolder ? btnStyle : {}}>确定</Button>
        </>
      }
    >
      <div className={styles.pickerFolderWrap}>
        <div className={styles.folderListContent}>
          <Checkbox.Group style={{ width: '100%' }} value={selected} onChange={checkboxChange}>
            <Space direction='vertical'>
              { folderList.map((item, index) => {
                return <Checkbox key={index} value={item.id} >{item.name}（{openingAreaTaskAlias}{item.clusterNum}{ showSpotFlag && ` 点位${item.siteLocationNum}` }）</Checkbox>;
              }) }
            </Space>
          </Checkbox.Group>
        </div>
        <div className={styles.folderFooter}>
          { !isAddFolder ? (
            <div className={styles.addBtn} onClick={() => setIsAddFolder(true)}>
              <IconFont iconHref='iconic_add_xiangqing' className='mr-4 fs-14' />
              添加收藏夹
            </div>) : (
            <div className={styles.addEnterContent}>
              { repeatTip && <div className={styles.errorTip}><ExclamationCircleOutlined /> {repeatTip}</div> }
              {/* <Input.Group compact className={styles.inputGroupContent}>

                <div className={styles.divider} />
                {/* <Button type='link' size='small' className={styles.cancelBtn} onClick={closeAddFolder}>取消</Button> */}
              {/* <Button type='link' size='small' className={styles.submitBtn} onClick={addFolder}>确定</Button> */}
              {/* </Input.Group> */}
              <div style={{ display: 'flex' }}>
                <Input
                  className={styles.folderInput}
                  value={addFolderName}
                  onChange={e => {
                    setAddFolderName(e.target.value);
                    setRepeatTip('');
                  }}
                  showCount
                  maxLength={10}
                />
                <div style={{ display: 'flex' }}>
                  <Button style={{ marginLeft: '10px', borderRadius: '4px' }} type='primary' className={styles.submitBtn} onClick={addFolder}>新建</Button>
                  <Button style={{ marginLeft: '10px' }} type='link' onClick={closeAddFolder}>取消</Button>
                </div>
              </div>
            </div>
          )
          }
        </div>
      </div>
    </Modal>
  );
};

export default PickFolderModal;
